import { Link, useLocation } from "react-router-dom";
import { ArrowRight, Trash2 } from "lucide-react";
import { useApp } from "@/context/AppContext";

const HIDDEN = ["/orcamento", "/os/", "/admin"];

export const SelectionBar = () => {
  const { sel, clearSel } = useApp();
  const { pathname } = useLocation();
  if (!sel.length || HIDDEN.some((h) => pathname.startsWith(h))) return null;
  return (
    <div className="no-print fixed bottom-[84px] left-4 right-24 z-40 fade-up xl:bottom-5 xl:left-1/2 xl:right-auto xl:w-auto xl:-translate-x-1/2" data-testid="selection-bar">
      <div className="flex items-center justify-between gap-3 border border-red-900/60 bg-[#111723]/95 px-4 py-3 shadow-2xl backdrop-blur-md">
        <span className="font-mono text-xs uppercase tracking-wider text-slate-300">
          <b className="text-lg text-red-500" data-testid="selection-count">{sel.length}</b> selecionado(s)
        </span>
        <button onClick={clearSel} className="p-1 text-slate-500 hover:text-red-400" data-testid="selection-clear" aria-label="Limpar seleção">
          <Trash2 className="h-4 w-4" />
        </button>
        <Link to="/orcamento" className="btn-red !px-4 !py-2 !text-xs" data-testid="selection-go-quote">
          Montar orçamento <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
};
